import { FeedbackOption } from '@copilot/data/responses/interface';
import { InboxManager } from '@copilot/data';
import notificationManager from '@copilot/common/utils/notificationManager';
import { NotificationContent } from '@copilot/common/constant/notificationContent';

/**
 * Custom hook for handling recommended message feedback
 * Encapsulates the API call and notification logic to eliminate prop drilling
 * @returns Object containing the updateFeedback function
 */
export function useRecommendedMessageFeedback() {
    async function onUpdateFeedback(
        threadId: string,
        rating: FeedbackOption,
        comment?: string,
        runId?: string
    ) {
        try {
            const success = await InboxManager.updateRecommendedMessageFeedback(
                threadId,
                rating,
                comment,
                runId
            );

            if (success) {
                notificationManager.showSuccessNotification(
                    NotificationContent.UpdateRecommendedMessageFeedback.Success
                );
            } else {
                notificationManager.showErrorNotification(
                    NotificationContent.UpdateRecommendedMessageFeedback.Fail
                );
            }
        } catch (error) {
            console.error('Error submitting feedback:', error);
            notificationManager.showErrorNotification(
                NotificationContent.UpdateRecommendedMessageFeedback.Fail
            );
        }
    }

    return {
        onUpdateFeedback,
    };
}
